import React from "react";

export const importantContent = {
  contact_us: {
    title: "Contact Us",
    content: (
      <>
        <p>Have questions or need support? Reach out to our team.</p>
        <p>
          <strong>Email:</strong> support@trendpad.io
          <br />
          <strong>Telegram Support:</strong> @TrendPadSupport
        </p>
      </>
    ),
  },
  social_links: {
    title: "Social Links",
    content: (
      <>
        <p>Stay updated with our latest news and announcements.</p>
        <ul>
          <li>
            <a
              href="https://x.com/trendcreatorai"
              target="_blank"
              rel="noopener noreferrer"
            >
              Twitter / X
            </a>
          </li>
          <li>
            <a
              href="https://www.instagram.com/trendcreatorai/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Instagram
            </a>
          </li>
          <li>
            <a
              href="https://www.tiktok.com/@trendcreatorai"
              target="_blank"
              rel="noopener noreferrer"
            >
              TikTok
            </a>
          </li>
          <li>
            <a
              href="https://www.youtube.com/@TrendCreatorai"
              target="_blank"
              rel="noopener noreferrer"
            >
              Youtube
            </a>
          </li>
          <li>
            <a
              href="https://t.me/+H-Ke5OjMz4w1YTdl"
              target="_blank"
              rel="noopener noreferrer"
            >
              Telegram Channel
            </a>
          </li>
        </ul>
      </>
    ),
  },
  terms_of_service: {
    title: "Terms of Service",
    content: (
      <>
        <p>
          By accessing and using TrendPad, you agree to our Terms of Service.
        </p>
        <p>
          TrendPad is a decentralized protocol. We do not control or endorse any
          specific project launched on our platform. Users must do their own
          research (DYOR) before participating in any presale.
        </p>
        {/* Add full terms here later */}
      </>
    ),
  },
  privacy_policy: {
    title: "Privacy Policy",
    content: (
      <>
        <p>
          Your privacy is important to us. TrendPad does not collect personal
          data such as names, addresses, or phone numbers. We interact only with
          public blockchain addresses.
        </p>
        <p>
          We may strictly use cookies for session management and standard
          analytics to improve user experience.
        </p>
      </>
    ),
  },
};
